import {
  Box,
  Container,
  Typography,
  Paper,
  Divider,
  Link as MuiLink,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  Shield as ShieldIcon,
  Report as ReportIcon,
  Gavel as GavelIcon,
  ContactSupport as ContactIcon,
  Block as BlockIcon,
  Verified as VerifiedIcon,
  PhoneAndroid as PhoneAndroidIcon,
  Email as EmailIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';

export default function ChildSafetyPage() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#f5f5f5',
        py: 6,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            backgroundColor: 'white',
          }}
        >
          {/* Header */}
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <ShieldIcon sx={{ fontSize: 64, color: '#d32f2f', mb: 2 }} />
            <Typography variant="h3" gutterBottom sx={{ fontWeight: 700 }}>
              Padrões de Segurança Infantil
            </Typography>
            <Typography variant="h6" color="text.secondary">
              Hostly - Política contra Abuso e Exploração Sexual Infantil (AESI)
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Sobre o Hostly */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Sobre o Hostly
            </Typography>
            <Typography paragraph>
              O <strong>Hostly</strong> é um aplicativo de <strong>gerenciamento de eventos e organização doméstica</strong> projetado para adultos que desejam planejar e gerenciar recepções, jantares, festas e eventos em suas casas. O app oferece:
            </Typography>
            <List dense sx={{ mb: 2 }}>
              <ListItem>
                <ListItemText primary="• Gerenciamento de convidados e listas de presença" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Organização de receitas e cardápios" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Controle de acervo doméstico" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• HostlyClub: uma rede social para adultos compartilharem ideias de decoração, receitas e dicas de organização de eventos" />
              </ListItem>
            </List>
            <Typography paragraph sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
              <strong>Importante:</strong> O Hostly é destinado exclusivamente a <strong>usuários adultos (18+ anos)</strong>. O conteúdo da plataforma é focado em organização doméstica e planejamento de eventos sociais entre adultos.
            </Typography>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Introdução */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Nosso Compromisso com a Segurança Infantil
            </Typography>
            <Typography paragraph>
              Embora o Hostly seja destinado a adultos e focado em organização doméstica, reconhecemos nossa responsabilidade com a segurança infantil em qualquer plataforma que permita conteúdo gerado por usuários.
            </Typography>
            <Typography paragraph>
              O Hostly tem <strong>tolerância zero</strong> para qualquer forma de Abuso e Exploração Sexual Infantil (AESI) ou Material de Abuso Sexual de Crianças (MASC/CSAM). Estamos comprometidos em fornecer um ambiente seguro e protegido para todos os nossos usuários.
            </Typography>
            <Typography paragraph>
              Esta política se aplica a todo conteúdo gerado por usuários em nossa plataforma, incluindo:
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="• Posts e fotos compartilhados no HostlyClub (nossa rede social)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Comentários e interações entre usuários" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Fotos de perfil e informações pessoais" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Mensagens e comunicações diretas" />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Conteúdo Proibido */}
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <BlockIcon sx={{ fontSize: 32, color: '#d32f2f', mr: 1 }} />
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Conteúdo Estritamente Proibido
              </Typography>
            </Box>
            <Typography paragraph>
              É <strong>terminantemente proibido</strong> em nossa plataforma:
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <BlockIcon color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Material de Abuso Sexual Infantil (MASC/CSAM)"
                  secondary="Qualquer imagem, vídeo, texto ou conteúdo que retrate, promova ou glorifique abuso sexual de crianças"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <BlockIcon color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Exploração Sexual Infantil"
                  secondary="Conteúdo que sexualize menores, incluindo nudez, poses sugestivas ou comportamento sexual envolvendo crianças"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <BlockIcon color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Aliciamento e Predação"
                  secondary="Tentativas de estabelecer contato inapropriado com menores ou comportamento predatório"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <BlockIcon color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Tráfico e Sextorsão"
                  secondary="Compartilhamento, venda ou distribuição de material ilegal envolvendo menores"
                />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Como Denunciar */}
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <ReportIcon sx={{ fontSize: 32, color: '#f57c00', mr: 1 }} />
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Como Denunciar Conteúdo Inapropriado
              </Typography>
            </Box>
            <Typography paragraph>
              Se você encontrar qualquer conteúdo que viole nossas políticas de segurança infantil:
            </Typography>

            <Paper elevation={1} sx={{ p: 2, mb: 2, backgroundColor: '#fff3e0' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <PhoneAndroidIcon sx={{ mr: 1, color: 'text.primary' }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Dentro do App
                </Typography>
              </Box>
              <List dense>
                <ListItem>
                  <ListItemText primary="1. Toque no ícone de três pontos (⋮) no post ou comentário" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="2. Selecione 'Denunciar conteúdo'" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="3. Escolha 'Segurança Infantil / AESI'" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="4. Forneça detalhes adicionais se possível" />
                </ListItem>
              </List>
            </Paper>

            <Paper elevation={1} sx={{ p: 2, mb: 2, backgroundColor: '#e3f2fd' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <EmailIcon sx={{ mr: 1, color: 'text.primary' }} />
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Por Email (Emergências)
                </Typography>
              </Box>
              <Typography>
                Para casos urgentes ou suspeitas graves, entre em contato imediatamente:
              </Typography>
              <Box sx={{ mt: 1, p: 2, backgroundColor: 'white', borderRadius: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <EmailIcon sx={{ mr: 1, fontSize: 20, color: 'text.secondary' }} />
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Email (marque como URGENTE - Segurança Infantil): <MuiLink href="mailto:contato@hostly.app.br?subject=URGENTE:%20Segurança%20Infantil%20-%20AESI">contato@hostly.app.br</MuiLink>
                  </Typography>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1, ml: 3.5 }}>
                  Assunto: "URGENTE: Segurança Infantil - AESI"
                  <br />
                  Tempo de resposta: Menos de 24 horas para casos críticos
                </Typography>
              </Box>
            </Paper>

            <Paper elevation={1} sx={{ p: 2, backgroundColor: '#ffebee' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <WarningIcon sx={{ mr: 1, color: '#d32f2f' }} />
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#d32f2f' }}>
                  Denúncia às Autoridades
                </Typography>
              </Box>
              <Typography paragraph>
                Se você tiver conhecimento de abuso infantil, também denuncie diretamente às autoridades:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText
                    primary="Brasil - Disque 100"
                    secondary="Disque Direitos Humanos (gratuito, 24h)"
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Brasil - SaferNet"
                    secondary="Central Nacional de Denúncias de Crimes Cibernéticos: new.safernet.org.br/denuncie"
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary="Internacional - NCMEC"
                    secondary="National Center for Missing & Exploited Children: CyberTipline.org"
                  />
                </ListItem>
              </List>
            </Paper>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Ações e Moderação */}
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <GavelIcon sx={{ fontSize: 32, color: '#1976d2', mr: 1 }} />
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Nossas Ações de Moderação
              </Typography>
            </Box>
            <Typography paragraph>
              Quando recebemos uma denúncia ou identificamos conteúdo que viola nossas políticas:
            </Typography>
            <List>
              <ListItem>
                <ListItemIcon>
                  <VerifiedIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Análise Imediata"
                  secondary="Todas as denúncias de AESI são priorizadas e analisadas em até 2 horas"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <VerifiedIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Remoção Urgente"
                  secondary="Conteúdo confirmado como MASC/CSAM é removido imediatamente (geralmente em minutos)"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <VerifiedIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Banimento de Usuário"
                  secondary="Infratores têm suas contas permanentemente suspensas, sem direito a apelação"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <VerifiedIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Denúncia às Autoridades"
                  secondary="Casos confirmados são reportados à SaferNet (Brasil) e NCMEC (internacional)"
                />
              </ListItem>
              <ListItem>
                <ListItemIcon>
                  <VerifiedIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary="Preservação de Evidências"
                  secondary="Mantemos logs e evidências conforme exigido por lei para investigações policiais"
                />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Tecnologias de Prevenção */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Medidas Preventivas e Tecnológicas
            </Typography>
            <Typography paragraph>
              O Hostly implementa múltiplas camadas de proteção:
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="• Moderação proativa de conteúdo gerado por usuários" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Verificação de idade dos usuários (maiores de 18 anos)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Sistemas de detecção e filtragem de conteúdo inadequado" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Análise de comportamento suspeito e padrões de abuso" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Cooperação com organizações de segurança infantil" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Treinamento contínuo de equipe de moderação" />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Contatos */}
          <Box sx={{ mb: 4 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <ContactIcon sx={{ fontSize: 32, color: '#388e3c', mr: 1 }} />
              <Typography variant="h5" sx={{ fontWeight: 600 }}>
                Contatos para Segurança Infantil
              </Typography>
            </Box>
            <Paper elevation={1} sx={{ p: 3, backgroundColor: '#e8f5e9' }}>
              <Typography variant="body1" paragraph>
                <strong>Email para Denúncias de AESI (Prioritário):</strong>
                <br />
                <MuiLink href="mailto:contato@hostly.app.br?subject=URGENTE:%20Segurança%20Infantil%20-%20AESI" sx={{ fontSize: '1.1rem' }}>
                  contato@hostly.app.br
                </MuiLink>
                <br />
                <Typography variant="body2" color="text.secondary" component="span">
                  Assunto: "URGENTE: Segurança Infantil - AESI"
                </Typography>
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Contato Geral:</strong>
                <br />
                <MuiLink href="mailto:contato@hostly.app.br">
                  contato@hostly.app.br
                </MuiLink>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Respondemos denúncias de AESI em até 2 horas. Casos urgentes são tratados imediatamente.
              </Typography>
            </Paper>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Compliance */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
              Conformidade Legal
            </Typography>
            <Typography paragraph>
              Esta política está em conformidade com:
            </Typography>
            <List dense>
              <ListItem>
                <ListItemText primary="• Estatuto da Criança e do Adolescente (ECA - Lei 8.069/90)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Marco Civil da Internet (Lei 12.965/14)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Lei Geral de Proteção de Dados (LGPD - Lei 13.709/18)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• Google Play Child Safety Standards Policy" />
              </ListItem>
              <ListItem>
                <ListItemText primary="• CyberTipline reporting requirements (NCMEC)" />
              </ListItem>
            </List>
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Footer */}
          <Box sx={{ textAlign: 'center', mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="body2" color="text.secondary" paragraph>
              Última atualização: Janeiro de 2025
            </Typography>
            <Typography variant="body2" color="text.secondary">
              <MuiLink href="/" color="inherit">
                Voltar ao Hostly
              </MuiLink>
              {' | '}
              <MuiLink href="/privacy-policy" color="inherit">
                Política de Privacidade
              </MuiLink>
              {' | '}
              <MuiLink href="/contact" color="inherit">
                Contato
              </MuiLink>
            </Typography>
            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#d32f2f' }}>
                Hostly - Tolerância Zero para AESI
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
